"use client";

import { signIn, signOut, useSession } from "next-auth/react";

import Link from "next/link";
import { usePathname } from "next/navigation";

import Icon from "@/components/ui/icon";
import Dropdown from "react-bootstrap/Dropdown";

import Version from "./version";

type UserDropdownProps = {
  handleClose?: () => void;
};

export default function UserDropdown({ handleClose }: UserDropdownProps) {
  const { data: session } = useSession();

  const pathname = usePathname();

  const avatarStyle = {
    width: 38,
    height: 38,
    cursor: "pointer",
  };

  if (!session) {
    return (
      <div
        onClick={() => signIn()}
        className="d-inline-flex justify-content-center align-items-center bg-dark text-light rounded-circle"
        style={avatarStyle}
      >
        <Icon icon="person fs-5" me={0} title="Sign in" />
      </div>
    );
  }

  return (
    <Dropdown>
      <Dropdown.Toggle className="btn-sm no-toggle-icon p-0" variant="">
        <div
          className="d-inline-flex justify-content-center align-items-center bg-dark text-light rounded-circle"
          style={avatarStyle}
        >
          <span className="font-weight-bold">{session?.user.initials}</span>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item active={pathname === "/auth/profile"} onClick={handleClose} as={"span"} className="p-0">
          <Link className="dropdown-item" href="/auth/profile">
            <Icon icon={"person-bounding-box"} />
            Profile
          </Link>
        </Dropdown.Item>
        <button className="dropdown-item" onClick={() => signOut()}>
          <Icon icon="power" />
          Sign Out
        </button>
        <hr className="dropdown-divider mb-1" />
        <div className="text-center">
          <Version />
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}
